export default __webpack_public_path__ + "static/media/logo_white_large.f5946b8e.png";